export class NikeBomsModal{
    season : string
    year : string

    constructor(season:string,year:string){
        this.season = season;
        this.year = year;
    }
}